import mockAxios, { AxiosResponse } from 'axios';

import { IDepartmentServiceMock } from './department.mock.types';

export const mockDepartmentService = (): IDepartmentServiceMock => ({
  fetchDepartments: jest.fn(),
  fetchDepartment: jest.fn(),
  createDepartment: jest.fn(),
  updateDepartment: jest.fn(),
  deleteDepartment: jest.fn()
});

export const mockDepartmentAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
